import { LicenseManager } from "ag-grid-enterprise";

const licenseKey = import.meta.env.VITE_AG_GRID_LICENSE;

LicenseManager.setLicenseKey(licenseKey);
